<div fxLayout="column" fxLayoutGap="10px">
  <div id='invalid' style="position: absolute; top: -100px; left: 0"></div>


  <div fxLayout="row" fxLayoutAlign="space-between center">
    <span class="title-endorder-card boldest">{{
      "endorder.date-and-hour" | translate | capitalize
      }}&nbsp;&nbsp;&nbsp;</span>
    <span *ngIf="!checkOnStor('date_order') || !checkOnStor('hour_order')"
      class="mat-subheading-1">{{"required"|translate}}&nbsp;&nbsp;&nbsp;</span>
    <span class="mat-subheading-1 warn-ico" *ngIf="error === 'invalidhour'">{{'DateOrderComponent.invalidHour'|translate}} </span>
  </div>


  <!-- Le commerçant a renseigné des horaires -->
  <div fxLayout="column" *ngIf="timetables.length > 0">

    <div fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column">




      <div class="form-field-endorder" [ngClass]="{
        'animErr warn':
          (error === 'dateorder' && !checkOnStor('date_order')) ||
          error === 'invalidDate'
      }" [class.animErr]="error === 'counterdate'" fxFlex="50" ngClass.xs="full-w" id="dateorder"
        *ngIf="timetables.length > 0 ">
        {{loaders.date}}


        <mat-form-field angulartics2On="click" angularticsAction="selectDate" angularticsCategory="order"
          appearance="outline" class="form-nopadd full-w" style="position: relative;" [floatLabel]="'never'">
          <div class="full-screen clicked" style="position: absolute; top: 0" (click)="picker1.open()"></div>
          <mat-label>{{'DATE'|translate}}</mat-label>
          <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDate" [min]="minDate"
            (dateChange)="setDate()" placeholder="{{'DATE'|translate}}" [(ngModel)]="currDate" disabled />
          <mat-datepicker-toggle matSuffix [for]="picker1">
          </mat-datepicker-toggle>
          <mat-datepicker touchUi #picker1 disabled="false" angularticsAction="selectDate" angularticsCategory="order">
          </mat-datepicker>


        </mat-form-field>

      </div>

      <!-- <div class="form-field-endorder" [ngClass]="{
          'animErr warn':
            (error === 'dateorder' && !checkOnStor('date_order')) ||
            error === 'invalidDate'
        }" [class.animErr]="error === 'counterdate'" fxFlex="50" ngClass.xs="full-w" id="dateorder"
        *ngIf="timetables.length > 0 && media.isActive('xs')">

        <mat-form-field angulartics2On="click" angularticsAction="selectDate" angularticsCategory="order"
          appearance="outline" class="form-nopadd full-w" style="position: relative;" [floatLabel]="'never'">
          <div class="full-screen clicked" style="position: absolute; top: 0" (click)="picker1.open()"></div>
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDate()" [min]="minDate"
            (dateChange)="setDate()" placeholder="Date" [(ngModel)]="currDate" disabled />
          <mat-datepicker-toggle matSuffix [for]="picker1">
          </mat-datepicker-toggle>
          <mat-datepicker touchUi #picker1 disabled="false" angularticsAction="selectDate" angularticsCategory="order">
          </mat-datepicker>
        </mat-form-field>

      </div> -->

      <!-- <div class="form-field-endorder" [ngClass]="{
          'animErr warn':
            (error === 'dateorder' && !checkOnStor('date_order')) ||
            error === 'invalidDate'
        }" [class.animErr]="error === 'counterdate'" fxFlex="50" ngClass.xs="full-w" id="dateorder"
        *ngIf="timetables.length > 0 && !media.isActive('xs')">

        <mat-form-field angulartics2On="click" angularticsAction="selectDate" angularticsCategory="order"
          appearance="outline" class="form-nopadd full-w" style="position: relative;" [floatLabel]="'never'">
          <div class="full-screen clicked" style="position: absolute; top: 0" (click)="picker1.open()"></div>
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDate()" [min]="minDate"
            (dateChange)="setDate()" placeholder="Date" [(ngModel)]="currDate" disabled />
       
            <mat-datepicker-toggle matSuffix [for]="picker1">
          </mat-datepicker-toggle>

          <mat-datepicker #picker1 disabled="false" angularticsAction="selectDate" angularticsCategory="order">
          </mat-datepicker>
        </mat-form-field>
      </div> -->




      <!-- date -->
      <div class="form-field-endorder" [ngClass]="{
          'animErr warn':
            (error === 'dateorder' && !checkOnStor('date_order')) ||
            error === 'invalidDate'
        }" [class.animErr]="error === 'counterdate'" fxFlex="50" ngClass.xs="full-w" id="dateorder"
        *ngIf="timetables.length < 1">


        <mat-form-field appearance="outline" class="form-nopadd full-w" [floatLabel]="'never'">
          <mat-label>{{'DATE'|translate}}</mat-label>
          <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDate" [min]="minDate"
            (dateChange)="setDate()" placeholder="{{'DATE'|translate}}" [(ngModel)]="currDate" disabled />
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

      </div>

      <!-- Heure -->
      <div class="form-field-endorder" [ngClass]="{
          'animErr warn':
            (error === 'hourorder' && !checkOnStor('hour_order')) ||
            error === 'invalidhour'
        }" [class.animErr]="error === 'counterdate'" fxFlex="50" ngClass.xs="full-w" id="dateorhourorderder"
        *ngIf="!closedForToday">

        <mat-form-field id="tetetetteet"appearance="outline" angulartics2On="click" angularticsAction="selectHour"
          angularticsCategory="order" class="form-nopadd full-w" floatLabel="always">
          <mat-label>{{'HOUR'|translate}}</mat-label>
          <mat-select [disabled]="!currDate || timetables.length < 1" [(ngModel)]="currHour"
            (selectionChange)="setHour()">
            <mat-option *ngFor="let hour of currHours" [value]="hour.hour" [disabled]="!hour.available">
              <div fxLayoutAlign="space-between">
                <span>{{ hour.hour }} - {{ hour.hour_end }}</span>
                <span class="warn-ico" *ngIf="!hour.available">  &nbsp;&nbsp;&nbsp;&nbsp; {{"unavailable"|translate}}</span>
              </div>
            </mat-option>
          </mat-select>


          <mat-spinner matPrefix diameter="20" *ngIf="loaders.hours"></mat-spinner>


        </mat-form-field>

      </div>

    </div>
    
    <!-- messagecommande hour date modified  -->
    <div *ngIf="messagecommande" fxLayout="column" style="padding-top: 5px; margin-bottom:-5px" class="mat-subheading-1 ">

      <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
  
          <mat-icon class="primary-ico">warning</mat-icon>
     
        <div fxLayoutAlign="start end"> {{(dateIschanged || (dateIschanged &&
          hoursIschanged)?"dateMessageCommand":"hourMessageCommand")|translate}}</div>
      </div>

      <div>{{"textMessageCommand"|translate}}</div>
    </div>

    <div *ngIf="closedForToday" fxFlex fxLayoutAlign="center center" style="padding-bottom: 1.34375em">
      <span class="mat-subheading-1 warn-ico boldest">{{"dateOrder.dayclosed"|translate}}</span>
    </div>

    <div *ngIf="error === 'counterdate'">
      <span class="mat-subheading-1 warn-ico">{{"dateOrder.badDate"|translate}}</span>
    </div>

    <div *ngIf="gapNeeded && saleMethod.limit_order_gap_str && saleMethod.limit_order_gap_str>0">
      <span class="mat-caption">{{"dateOrder.minimumOrderDeliveryTime"|translate}}
        <strong>{{ saleMethod.limit_order_gap_str }}</strong></span>
    </div>
  </div>

  <!-- Le commernçant n'a pas renseigné d'horaires -->
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutAlign="center center"
    *ngIf="timetables.length < 1" class="layout-padd">traderNoHorary
    <span class="mat-subheading-1 warn-ico boldest">{{"dateOrder.traderNoHorary"|translate}}</span>
  </div>

</div>